import { render, staticRenderFns } from "./FeeEdit.vue?vue&type=template&id=8a76ba90"
import script from "./FeeEdit.vue?vue&type=script&lang=js"
export * from "./FeeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports